module.exports = __webpack_public_path__ + "img/cw_ys_caiWuYingShou.641ff4ee.svg";